import React, { useState } from "react";
import { Form, Input, Button, Card, Typography, message } from "antd";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import logo from "../logo.png";

const { Title, Text } = Typography;

const LoginPage = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const res = await axios.post("https://backapp.sidelsur.com/api/auth/login", values);
      localStorage.setItem("usuario", values.nombreUsuario);
      localStorage.setItem("token", res.data.token);
      // Store user role if available in response
      if (res.data.rol) {
        localStorage.setItem("rol", res.data.rol);
      }
      message.success("Login exitoso");

      // Redirect based on role
      const userRole = res.data.rol;
      if (userRole === "Operador") {
        navigate("/download/app");
      } else {
        navigate("/procesos");
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        message.warning("Contraseña o usuario incorrectos");
      } else {
        message.error("Error al iniciar sesión. Por favor intente nuevamente.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        height: "100vh",
        background: "linear-gradient(135deg, #1677ff 0%, #0043a8 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card
        style={{
          width: 450,
          borderRadius: 14,
          paddingLeft: 24,
          paddingRight: 24,
          boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
          textAlign: "center",
        }}
      >
        <div style={{ marginBottom: 24 }}>
          <img src={logo} alt="Interpack Logo" style={{ maxWidth: "200px", marginBottom: 16 }} />
          <Title level={3} style={{ marginBottom: 0 }}>
            Iniciar Sesión
          </Title>
          <Text type="secondary">Accede a tu cuenta</Text>
        </div>

        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="nombreUsuario"
            label="Usuario"
            rules={[{ required: true, message: "Por favor ingresa tu usuario" }]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="Tu usuario"
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="clave"
            label="Contraseña"
            rules={[{ required: true, message: "Por favor ingresa tu contraseña" }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Tu contraseña"
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              size="large"
              style={{ borderRadius: 6 }}
            >
              Ingresar
            </Button>
          </Form.Item>
        </Form>

        <Text type="secondary" style={{ fontSize: 12 }}>
          © {new Date().getFullYear()} YIDEASA S.A.
        </Text>
      </Card>
    </div>
  );
};

export default LoginPage;
